if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
                this.form.addEventListener(
                    "submit",
                    this.onSubmitHandler.bind(this)
                );
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
                if (this.submitButton.getAttribute("aria-disabled") === "true")
                    return;

        let priceElement;
        const pageType = this.determinePageType();

        const skuInput = this.form.querySelector("[name=sku]");
        const sku = skuInput ? skuInput.value : null;

        if (pageType === "PDP") {
          priceElement = document.querySelector("#discounted-price");
        } else if (pageType === "Collections" || pageType === "Homepage" || pageType === "SearchPage") {
          priceElement = document.querySelector(`#price-${sku}`);
        } else if (pageType === 'WishlistPage'){
          priceElement = document.querySelector(`#discounted-price-${sku}`);
        }

        if (priceElement) {
          const priceValue = parseFloat(
                        priceElement.textContent
                            .trim()
                            .replace(/[^0-9.-]+/g, "")
          );

          if (isNaN(priceValue) || priceValue === 0) {
            // alert(
            //   "Cannot add to cart. Please contact your sales representative."
            // );
            // return;
          }
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
                this.querySelector(".loading__spinner").classList.remove(
                    "hidden"
                );

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);

        const { customPricingUrl, companyId, locationId, customerId, shopId } = window.globalData || {};

        try {
          const fetchPricingToken = await fetch(
            `${customPricingUrl}/shop/${shopId}/customPricing?skus=${sku}&locationId=${locationId}&companyId=${companyId}&customerId=${customerId}`
          );
          const pricingData = await fetchPricingToken.json();
          const priceData = pricingData[0]?.prices;
          const locations = pricingData[0]?.locations;
          const groupedByMaxPrice = Object.values(
            priceData.reduce((acc, item) => {
              // Create a unique key for grouping
              const key = `${item.customerPriceClass}|${item.customPricingType}|${item.breakQty}`;
          
              // If the key doesn't exist or the current item has a higher price, update the stored value
              if (!acc[key] || item.price > acc[key].price) {
                acc[key] = { 
                  ...item // Ensure all fields are included
                };
              }
          
              return acc;
            }, {})
          );

          if (pricingData && priceData && priceData?.length > 0) {
            if (priceData) {
              formData.append("properties[_prices]", JSON.stringify(groupedByMaxPrice));
            }

            if (locations) {
              formData.append(
                "properties[_locations]",
                JSON.stringify(locations)
              );
            }

            if (locationId) {
              formData.append("properties[_currentLocationId]", locationId);
            }
          } else {
            // If no priceToken is found, log the case but continue with the cart process
            console.log("priceData not found, proceeding without it.");
            throw "PriceData not found."
          }
        } catch (e) {
          console.error("Something went wrong in the custom pricing");
              alert(
              "Cannot add to cart. Please contact your sales representative."
            );
            this.submitButton.classList.remove("loading");
            this.submitButton.setAttribute("aria-disabled", false);
            this.querySelector(".loading__spinner").classList.add(
              "hidden"
            );
            return;
        }

        // Add sections and other required info to the form data
        if (this.cart) {
          formData.append(
            "sections",
                        this.cart
                            .getSectionsToRender()
                            .map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                                this.submitButton.querySelector(
                                    ".sold-out-message"
                                );
              if (!soldOutMessage) return;
                            this.submitButton.setAttribute(
                                "aria-disabled",
                                true
                            );
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;

            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch(() => {
            console.error("Something went wrong");
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
                        if (
                            this.cart &&
                            this.cart.classList.contains("is-empty")
                        )
              this.cart.classList.remove("is-empty");
                        if (!this.error)
                            this.submitButton.removeAttribute("aria-disabled");
                        this.querySelector(".loading__spinner").classList.add(
                            "hidden"
                        );
          });
      }

      determinePageType() {
        const url = window.location.pathname;

        if (url.includes("/products/")) {
          return "PDP";
        } else if (url.includes("/collections/")) {
          return "Collections";
        } else if (url === "/"){
          return "Homepage";
        } else if (window.location.search.includes("view=wishlist")) {
          return "WishlistPage";
        } else if (url.includes("/search")) {
          return "SearchPage";
        }
    

        return "Unknown";
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

                this.errorMessageWrapper.toggleAttribute(
                    "hidden",
                    !errorMessage
                );

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
                    this.submitButtonText.textContent =
                        window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
